import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { P, H6, Subtext, FlexRow } from '@contently/toolkit';
import styled from '@emotion/styled';
import Benchmark from './benchmark';
import FilterContext from './FilterContext';
import { US_AND_CANADA } from './utils';

const Title = styled(H6)`
  margin-bottom: 11px;
`;

const Value = styled(P)`
  margin-bottom: 0.75rem !important;
  font-size: 28px;
`;

function CalculationBox({
  id,
  title,
  value,
  subtext,
  previousValue,
  valuePercentage,
  valueChangeDirection,
  lastFullMonthName,
  benchmarkValue,
  benchmarkPercentage,
  // benchmarkBar,
  positive
}) {
  const filter = useContext(FilterContext);

  return (
    <div id={id}>
      <Title>{title}</Title>
      <Value>{value}</Value>
      <FlexRow>
        <Benchmark
          value={previousValue}
          percentage={valuePercentage}
          type="monthlyComparison"
          lastFullMonthName={lastFullMonthName}
          valueChangeDirection={valueChangeDirection}
        />
        {filter === US_AND_CANADA && (
          <Benchmark
            value={benchmarkValue}
            percentage={benchmarkPercentage}
            type="pubComparison"
            positive={positive}
          />
        )}
      </FlexRow>
      <Subtext>{subtext}</Subtext>
    </div>
  );
}

export default CalculationBox;

CalculationBox.defaultProps = {
  benchmarkPercentage: null,
  positive: null,
  benchmarkValue: null,
  previousValue: null,
  valuePercentage: null,
  lastFullMonthName: null,
  valueChangeDirection: null
};

CalculationBox.propTypes = {
  title: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  subtext: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
  previousValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  valuePercentage: PropTypes.number,
  lastFullMonthName: PropTypes.string,
  benchmarkValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  benchmarkPercentage: PropTypes.number,
  // benchmarkBar: PropTypes.string.isRequired,
  positive: PropTypes.bool,
  valueChangeDirection: PropTypes.bool
};



// WEBPACK FOOTER //
// ./app/javascript/app/components/value/calculation_box.jsx